import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { TripDate, TripDateFilter } from '../../lib/types/models/trip-booking/trip-date'
import {
  TripPlaceToCenterRequest,
  TripPlaceToCenterRequestFilter
} from '../../lib/types/models/trip-place-to-center-request/trip-place-to-center-request'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripDate(id: number, options?: PaginationRequest<TripDateFilter>) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest<TripDateFilter>>(
        constructApiUrl(API.tripDates.get.url, { id }),
        options
      )
    )
    .get<TripDate>()
}

export const getTripPlaceToCenterRequests = (
  tripDateId: number,
  options?: PaginationRequest<TripPlaceToCenterRequestFilter>
) => {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest<TripPlaceToCenterRequestFilter>>(
        constructApiUrl(API.tripDates.getTripPlaceToCenterRequests.url, { id: tripDateId }),
        options
      )
    )
    .get<PaginationResponse<TripPlaceToCenterRequest>>()
}
